<p-dialog
  [(visible)]="visible"
  (visibleChange)="onVisibleChange($event)"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '500px', height: 'auto' }">

  <!-- HEADER CUSTOMIZADO COM WAVE -->
  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-search" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <!-- Selecao (API interna, id != null) -->
        <ng-container *ngIf="origem === 'interna'">
          <h2>{{ 'ruc_busca.dialogs.ruc_encontrado_titulo' | translate }}</h2>
          <p>{{ 'ruc_busca.infos.ja_existe_cadastro' | translate }}</p>
        </ng-container>
        <!-- Confirmacao (API externa, id == null) -->
        <ng-container *ngIf="origem === 'externa'">
          <h2>{{ 'ruc_busca.dialogs.pessoa_existente' | translate }}</h2>
          <p>{{ 'ruc_busca.infos.encontramos_cadastro' | translate }}</p>
        </ng-container>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <!-- Resultado unico -->
    <div *ngIf="resultados.length === 1" class="ruc-resultado-unico">
      <div class="ruc-resultado-item ruc-resultado-item--selecionado">
        <div class="ruc-resultado-info">
          <span class="ruc-resultado-ruc">{{ resultados[0].ruc }}</span>
          <span class="ruc-resultado-nome">{{ resultados[0].nome }}</span>
        </div>
      </div>
      <!-- Texto diferente conforme origem -->
      <p *ngIf="origem === 'externa'" class="ruc-resultado-pergunta">{{ 'ruc_busca.infos.deseja_adicionar' | translate }}</p>
      <p *ngIf="origem === 'interna'" class="ruc-resultado-pergunta">{{ 'ruc_busca.infos.deseja_usar_dados' | translate }}</p>
    </div>

    <!-- Multiplos resultados (apenas API interna pode retornar mais de 1) -->
    <div *ngIf="resultados.length > 1" class="ruc-resultado-lista">
      <p class="ruc-resultado-pergunta">{{ 'ruc_busca.dialogs.selecione_registro' | translate }}</p>
      <div
        *ngFor="let pessoa of resultados"
        class="ruc-resultado-item"
        [class.ruc-resultado-item--selecionado]="pessoaSelecionada === pessoa"
        (click)="pessoaSelecionada = pessoa">
        <div class="ruc-resultado-info">
          <span class="ruc-resultado-ruc">{{ pessoa.ruc }}</span>
          <span class="ruc-resultado-nome">{{ pessoa.nome }}</span>
        </div>
        <i *ngIf="pessoaSelecionada === pessoa" class="pi pi-check ruc-resultado-check"></i>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="ruc-footer-buttons">
      <button pButton class="p-button-secondary" (click)="onRecusar()">
        {{ 'ruc_busca.buttons.nao_preencher_manual' | translate }}
      </button>
      <button pButton (click)="onConfirmar()"
        [disabled]="resultados.length > 1 && !pessoaSelecionada">
        {{ 'ruc_busca.buttons.sim_usar_dados' | translate }}
      </button>
    </div>
  </ng-template>
</p-dialog>
